export default `
<div
    class="{{class}} js-dropdown dropdown"
    id="{{id}}"
    tabindex="-1"
>
  {{> @partial-block}}
</div>

`;
